import { useRef, useEffect, useState } from "react";
import { cn } from "@/lib/utils";

type CollapseProps = {
  isOpen: boolean;
  children: React.ReactNode;
  className?: string;
};

export const Collapse = ({ isOpen, children, className }: CollapseProps) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState<number | undefined>(isOpen ? undefined : 0);

  useEffect(() => {
    if (!contentRef.current) return;
    if (isOpen) {
      setHeight(contentRef.current.scrollHeight);
      const timeout = setTimeout(() => setHeight(undefined), 200);
      return () => clearTimeout(timeout);
    } else {
      setHeight(contentRef.current.scrollHeight);
      requestAnimationFrame(() => setHeight(0));
    }
  }, [isOpen]);

  return (
    <div
      className={cn("overflow-hidden transition-[height] duration-200 ease-in-out", className)}
      style={{ height: height !== undefined ? `${height}px` : "auto" }}
    >
      <div ref={contentRef}>{children}</div>
    </div>
  );
};
